//Styles
import Styles from "./Dock.module.scss"
import classnames from "classnames";
import "./iconProvider.css"
import { APP_KEY_IDS } from "../../constants/constants";

//Redux
import { flipState } from "../../actions";
import { RootStateOrAny, useDispatch,useSelector } from "react-redux";
import handleAppWindow from "../../reducers/windowState";
import { handleDockPosition } from "../../reducers/dock";



export const DOCK_MENU = [
    {
        id: APP_KEY_IDS.FINDER,
        label: "Finder",
        description:"This is Spotlight Search. You can search apps here.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.HOME,
        label: "Home",
        description:"File Explorer containing all the important files",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.ABOUT_ME,
        label: "About",
        description:"Basic Information about me is present in this.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.APP_STORE,
        label: "AppSotre",
        description:"It contains all the apps I have developed till date.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.SAFARI,
        label: "Safari",
        description:"This is a browser.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.GALLERY,
        label: "Gallery",
        description:"Itt contains pictures.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.XCODE,
        label: "XCode",
        description:"This is IDE for coding in a few different languages.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.SPOTIFY,
        label: "Spotify",
        description:"Spotify app for listening to music.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.SETTINGS,
        label: "Preferences",
        description:"This contains setting for this website. You can tweak the UI here.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.MESSAGES,
        label: "Messages",
        description:"This is a chatting app. I can be contacted here via chatting.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.MUSIC,
        label: "Apple Music",
        description:"Apple Music app for listening to music.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.NOTES,
        label: "Notes",
        description:"This is a text editor.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.CAMERA,
        label: "Camera",
        description:"This is a camera app.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.CHROME,
        label: "Chrome",
        description:"This is for downloading the chrome.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.DEV_SKILLS,
        label: "Skills",
        description:"This app shows the skills I have in development.",
        onClick: () => { }
    },
    {
        id: APP_KEY_IDS.CONTACTS,
        label: "Contact",
        description:"This app shows my details and contact information.",
        onClick: () => { }
    }
]
const Dock = () => {

    const dispatch = useDispatch()

    const appState = useSelector((state:RootStateOrAny)=>state.handleAppWindow);
    const autoHideDock = useSelector((state:RootStateOrAny)=>state.handleDockVisibility);
    const dockPosition = useSelector((state:RootStateOrAny)=>state.handleDockPosition)

    return (
        <div className={classnames(Styles.container,Styles[dockPosition],autoHideDock ? Styles.hide:Styles.dont_hide)} >

            <div className={classnames(Styles.dock, "glassBackground")} >
                {DOCK_MENU.map((app) => {
                    return (
                        <div className={Styles.app_container} key={app.id} onClick={()=>{dispatch(flipState(app.id))}}>
                            <div className={Styles.app_icon} id={app.id} ></div>
                            <div className={Styles.app_label}>{app.label}</div>
                            <div className={classnames(Styles.app_state, appState[app.id] && Styles.visible)}/>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Dock
